import { render } from "./forgottenScan.vue?vue&type=template&id=f48cc758"
import script from "./forgottenScan.vue?vue&type=script&lang=js"
export * from "./forgottenScan.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__